
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "filiation-card",
  props: {
    title: String,
    description: String,
    buttonText: String,
    image: String,
    modalId: String,
  },
  components: {},
  setup() {
    const router = useRouter();
    const listDeprivedLiberty = () => {
      router.push({ name: "listDeprivedLiberty" });
    };
    return {
      listDeprivedLiberty,
    };
  },
});
